import "./ForensicGynecology.module.css";
import Header from "@/reusable_sections/Header";
import Consulenza from "./sections/Consulenza";
import ForensicExpertise from "./sections/ForensicExpertise";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function ForensicGynecologyPage() {
  return <div>
      <Header />
      <Consulenza />
      <ForensicExpertise />
      <Consultation />
      <Footer />
    </div>;
}